import { styled } from '@/stitches.config';

import { Box } from '@base-app';

export const SidebarMenuItemContainerStyled = styled(Box, {
  alignItems: 'center',
  borderRadius: '$8',
  color: '$darkBlue300',
  display: 'flex',
  margin: '$7 $4 $7 $4',
  padding: '$3 $4 $3 $iconPadding',
  '&:hover': {
    cursor: 'pointer',
  },
  variants: {
    selected: {
      true: {
        backgroundColor: '$darkBlue300',
        color: '$white',
      },
    },
  },
});

export const MenuItemIconStyled = styled(Box, {
  display: 'flex',
  justifySelf: 'flex-start',
});

export const MenuItemLabelStyled = styled('label', {
  opacity: 0,
  transition: 'opacity 1ms ease',
  whiteSpace: 'nowrap',
  '&:hover': {
    cursor: 'pointer',
  },
  variants: {
    isOpen: {
      true: {
        fontSize: '$md',
        fontWeight: '$medium',
        justifySelf: 'flex-start',
        lineHeight: '$6',
        marginLeft: '$4',
        opacity: 1,
        transition: 'opacity 0.5s ease',
      },
    },
  },
});
